import React from 'react';
import { ExerciseListScreen } from './screens/ExerciseListScreen';

const Onboarding = () => (
   <ExerciseListScreen
      title="Getting Started"
      linkPrefix="/app/exercise"
      description="Start learning music theory, mixing, and mastering with these ear training exercises for producers!"
   />
);

// needed for lazy load
// eslint-disable-next-line import/no-default-export
export default Onboarding;
